<!-- 智能车型匹配-通过互换码 -->
import { constants } from 'os';
<template>
    <div v-loading="loading">
        <div class="row-head">
            <span>品牌</span>
            <el-select v-model="checkedSelect" size="small" @change="changeSelectList">
                <el-option label="不限" value=""></el-option>
                <el-option
                    v-for="optionItem in brandList"
                    :label="optionItem.Brand"
                    :key="optionItem.BrandId"
                    :value="optionItem.BrandId"
                ></el-option>
            </el-select>
            <el-button
                class="search-btn btn-primary"
                size="small"
                @click="chooseAs()"
            >确定 (选中{{ selection.length }}项)</el-button>
        </div>
        <div class="match-table">
            <u-table
                ref="plTable"
                height="500"
                :data="tableData"
                use-virtual
                border=""
                :big-data-checkbox="true"
                :header-cell-style="setRowStyle"
                @selection-change="onColumnSelect"
            >
                <u-table-column type="selection" width="50"/>
                <u-table-column prop="ModelDesc" key="AutoSerieId" label="车型"/>
            </u-table>
        </div>
    </div>
</template>
<script>
export default {
  name: "",
  props: ["changeCode"],
  components: {},
  data() {
    return {
      loading: false,
      checkedSelect: "",
      sourceData: [],
      tableData: [],
      brandList: [],
      selection: []
    };
  },
  created() {},
  mounted() {
    this.getAutoSeriesByApCode();
  },
  methods: {
    getAutoSeriesByApCode() {
      this.loading = true;
      this.$util
        .axiosPost({
          url: "/api/EntpGoods/GetAutoSeriesByApCode",
          data: { changeCode: this.changeCode.replace(/\n/g, ",") },
          hideLoading: true
        })
        .then(res => {
          let data = res.data;
          if (data) {
            this.sourceData = data.Series;
            this.tableData = data.Series;
            this.brandList = data.Brands;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 切换智能车型品牌
    changeSelectList(aId) {
      if (aId) {
        let list = this.sourceData;
        // 切换选框可选的列表
        this.tableData = list.filter(item => {
          return item.BrandId === aId;
        });
      } else {
        this.tableData = this.sourceData;
      }
    },
    onColumnSelect(val) {
      this.selection = val;
    },
    chooseAs() {
      if (this.selection.length > 0) this.$emit("closeDialog", this.selection);
    },
    setRowStyle(param) {
      return `background-color: #f2f6fc`;
    }
  }
};
</script>
<style lang="less" scoped>
.row-head {
  padding: 12px 16px;
  // background-color: #f5f7fa;
  // border-top: 1px solid #ebeef5;
  // border-bottom: 1px solid #ebeef5;
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    flex-shrink: 0;
    margin-right: 16px;
  }
}
</style>
<style lang="less">
.match-table {
  .el-table__body {
    .el-table__row {
      .cell {
      }
      td {
        height: 40px !important;
        padding: 2px 0;
      }
    }
  }
}
</style>
